import type { AddressInput } from 'typings/graphql'


// returns address in with required fields
export const getAddressInput = (values: PaymentModule.ShippingFormFields): AddressInput => {
  const { firstName, lastName, country, postalCode, region, city, street1, street2, phone } = values

  return {
    firstName,
    lastName,
    country,
    postalCode,
    region,
    city,
    street1,
    street2,
    phone,
  }
}
